// src/components/Fuß/Impressum.js
import React from 'react';
import './Impressum.css';

function Impressum() {
  return (
    <div className="impressum-container">
      <h1 className="impressum-title">Impressum</h1>

      <p>
        <strong>prosperly GmbH</strong><br/>
        Poschingerstraße 25<br/>
        12157 Berlin<br/>
        Handelsregister: HRB 266111<br/>
        Registergericht: Amtsgericht Berlin Charlottenburg<br/>
        Wohnimmobilienverwalter - erlaubnispflichtige Tätigkeit nach § 34c Abs. 1 der Gewerbeordnung
      </p>

      <p>
        <strong>Vertreten durch:</strong><br/>
        Eric Hinzmann
      </p>

      <p>
        <strong>Kontakt</strong><br/>
        Telefon: +49 (0) 151 41333478<br/>
        E-Mail: info@service.prosperly.de
      </p>

      <p>
        <strong>Umsatzsteuer-ID</strong><br/>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br/>
        29/480/32630
      </p>

      <p>
        <strong>Angaben zur Berufshaftpflichtversicherung</strong><br/>
        Name und Sitz des Versicherers:<br/>
        Hiscox SA<br/>
        Arnulfstraße 31<br/>
        80636 München<br/>
        Geltungsraum der Versicherung: Deutschland
      </p>

      <p>
        <strong>EU-Streitschlichtung</strong><br/>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br/>
        <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
          https://ec.europa.eu/consumers/odr/
        </a>.<br/>
        Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </p>
    </div>
  );
}

export default Impressum;

